import { IReportData } from "src/entities/reports/IReportData";
import { IReport, ActionCreators } from "../../../store/rapporten/jaarverslag/AfgeslotenOpPvb";
import Medewerker from "../../../entities/Medewerker";
import { IApplicationState } from "../../../store";
import { Dispatch } from "redux";
import * as React from "react";
import StdRapport from "../common/StandaardRapportFull";
import { connect } from "react-redux";

// Setup Title
const reportTitle = "Afgesloten - OP PVB (VAPH)";
const selectDates = true;
const selectMedewerker = true;

// Mapping Dynamic Properties
interface IPropsFromState {
    rapport: IReportData<IReport>;
    selectedUser: Medewerker;
    startDate: Date;
    endDate: Date;
}

const mapStateToProps = (state: IApplicationState): IPropsFromState => ({
    rapport: state.rapporten.jaarverslag.AfgeslotenOpPvb.Report,
    selectedUser: state.selectie.selectedMedewerker,
    startDate: state.selectie.selectedDateRange.startDate,
    endDate: state.selectie.selectedDateRange.endDate
});

// Mapping Event Dispatcher
interface IPropsFromDispatch {
    FetchReport: typeof ActionCreators.FetchReport;
    DownloadReport: typeof ActionCreators.FetchReportXlsx;
}

const mapDispatchToProps = (dispatch: Dispatch): IPropsFromDispatch => ({
    FetchReport: (userId: string, startDate: Date, endDate: Date) => dispatch(ActionCreators.FetchReport(userId, startDate, endDate)),
    DownloadReport: (userId: string, startDate: Date, endDate: Date) => dispatch(ActionCreators.FetchReportXlsx(userId, startDate, endDate))
});

// Setup Report
type AllProps = IPropsFromState & IPropsFromDispatch;

class Rapport extends React.Component<AllProps> {
    constructor(props: AllProps) {
        super(props);
    }

    public render() {
        return (
            <StdRapport
                title={reportTitle}
                selectDate={selectDates}
                selectMedewerker={selectMedewerker}
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                selectedUser={this.props.selectedUser}
                rapport={this.props.rapport}
                FetchReport={this.props.FetchReport}
                FetchReportXlsx={this.props.DownloadReport}
                columns={[
                    { Header: "Medewerker", accessor: "medewerker" },
                    { Header: "Aanmeldingsdatum", accessor: "datumAanmelding", Cell: (p: any) => <span>{p.value == null ? "" : new Date(p.value).toLocaleDateString()}</span> },
                    { Header: "Vraag naar OpPvb", accessor: "vraagNaarPvb", Cell: (p: any) => <span>{p.value ? "Ja" : "Nee"}</span> },
                    { Header: "Dossier", accessor: "dossierNummer" },
                    { Header: "Naam", accessor: "naam" },
                    { Header: "Afsluitingsdatum", accessor: "datumAfgesloten", Cell: (p: any) => <span>{p.value == null ? "" : new Date(p.value).toLocaleDateString()}</span> },
                    { Header: "PVB datum", accessor: "datumPvb", Cell: (p: any) => <span>{p.value == null ? "" : new Date(p.value).toLocaleDateString()}</span> }
                ]}
            />
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Rapport);